//frontend/src/admin/ClientFeaturesManagement.js
import React, { useState, useEffect } from 'react';
import { 
  FaPlus, FaEdit, FaTrash, FaSave, FaTimes, FaStar,
  FaShippingFast, FaDollarSign, FaCheckCircle, FaClock,
  FaBoxOpen, FaPhone, FaGlobe, FaTruck, FaUsers,
  FaShieldAlt, FaAward, FaHeart, FaBolt, FaLeaf
} from 'react-icons/fa';
import axiosInstance from '../axios';
import '../styles/admin.css';

const ClientFeaturesManagement = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingFeature, setEditingFeature] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    icon_name: 'FaCheckCircle',
    icon_color: 'blue',
    display_order: 0,
    is_active: true
  });

  // Icon сонголтууд
  const iconOptions = [
    { name: 'FaShippingFast', label: 'Хурдан хүргэлт', component: <FaShippingFast /> },
    { name: 'FaDollarSign', label: 'Үнэ', component: <FaDollarSign /> },
    { name: 'FaCheckCircle', label: 'Найдвартай', component: <FaCheckCircle /> },
    { name: 'FaClock', label: 'Цаг', component: <FaClock /> },
    { name: 'FaBoxOpen', label: 'Ачаа', component: <FaBoxOpen /> },
    { name: 'FaPhone', label: 'Дэмжлэг', component: <FaPhone /> },
    { name: 'FaGlobe', label: 'Олон улс', component: <FaGlobe /> },
    { name: 'FaTruck', label: 'Тээвэр', component: <FaTruck /> },
    { name: 'FaUsers', label: 'Хэрэглэгчид', component: <FaUsers /> },
    { name: 'FaShieldAlt', label: 'Аюулгүй', component: <FaShieldAlt /> },
    { name: 'FaAward', label: 'Шагнал', component: <FaAward /> },
    { name: 'FaHeart', label: 'Найрсаг', component: <FaHeart /> },
    { name: 'FaBolt', label: 'Хурдан', component: <FaBolt /> },
    { name: 'FaLeaf', label: 'Эко', component: <FaLeaf /> }
  ];

  // Өнгөний сонголтууд
  const colorOptions = [
    { value: 'blue', label: 'Цэнхэр', class: 'bg-blue-500' },
    { value: 'green', label: 'Ногоон', class: 'bg-green-500' },
    { value: 'purple', label: 'Нил ягаан', class: 'bg-purple-500' },
    { value: 'orange', label: 'Улбар шар', class: 'bg-orange-500' },
    { value: 'red', label: 'Улаан', class: 'bg-red-500' },
    { value: 'yellow', label: 'Шар', class: 'bg-yellow-500' },
    { value: 'pink', label: 'Ягаан', class: 'bg-pink-500' },
    { value: 'indigo', label: 'Хөх', class: 'bg-indigo-500' }
  ];

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('/api/client/features');
      if (response.data.success) {
        setFeatures(response.data.data || []);
      }
    } catch (error) {
      console.error('Fetch features error:', error);
      alert('Давуу тал татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      alert('Гарчиг оруулна уу');
      return;
    }

    setLoading(true);
    
    try {
      if (editingFeature) {
        await axiosInstance.put(`/api/client/features/${editingFeature.id}`, formData);
        alert('✅ Давуу тал амжилттай шинэчлэгдлээ');
      } else {
        await axiosInstance.post('/api/client/features', formData);
        alert('✅ Давуу тал амжилттай үүсгэгдлээ');
      }
      
      setShowModal(false);
      resetForm();
      fetchFeatures();
    } catch (error) {
      console.error('Save feature error:', error);
      alert('❌ ' + (error.response?.data?.msg || 'Алдаа гарлаа'));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (feature) => {
    setEditingFeature(feature);
    setFormData({
      title: feature.title,
      description: feature.description || '',
      icon_name: feature.icon_name || 'FaCheckCircle',
      icon_color: feature.icon_color || 'blue',
      display_order: feature.display_order || 0,
      is_active: feature.is_active
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Энэ давуу талыг устгахдаа итгэлтэй байна уу?')) return;
    
    setLoading(true);
    try {
      await axiosInstance.delete(`/api/client/features/${id}`);
      alert('✅ Давуу тал амжилттай устгагдлаа');
      fetchFeatures();
    } catch (error) {
      console.error('Delete feature error:', error);
      alert('❌ ' + (error.response?.data?.msg || 'Устгахад алдаа гарлаа'));
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEditingFeature(null);
    setFormData({
      title: '',
      description: '',
      icon_name: 'FaCheckCircle',
      icon_color: 'blue',
      display_order: 0,
      is_active: true
    });
  };

  // Icon харуулах
  const getIconComponent = (iconName) => {
    const icon = iconOptions.find(opt => opt.name === iconName);
    return icon ? icon.component : <FaCheckCircle />;
  };

  // Өнгөний class
  const getColorClass = (color) => {
    const colorOption = colorOptions.find(opt => opt.value === color);
    return colorOption ? colorOption.class : 'bg-blue-500';
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 flex items-center">
            <FaStar className="mr-3 text-yellow-500" />
            Давуу тал удирдлага
          </h1>
          <p className="text-sm text-gray-600">
            Нүүр хуудасны "Манай давуу тал" хэсгийг удирдах
          </p>
        </div>
        <button
          onClick={() => {
            resetForm();
            setShowModal(true);
          }}
          className="custom-button flex items-center space-x-2 px-6 py-3"
        >
          <FaPlus className="w-4 h-4" />
          <span>Шинэ нэмэх</span>
        </button>
      </div>

      {/* Давуу талын жагсаалт */}
      <div className="table-container bg-white rounded-lg shadow">
        <div className="table-header px-4 py-3 border-b">
          <h2 className="table-title">Давуу талын жагсаалт ({features.length})</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="data-table w-full">
            <thead>
              <tr>
                <th className="px-4 py-3 w-20">Дараалал</th>
                <th className="px-4 py-3 w-20">Icon</th>
                <th className="px-4 py-3">Гарчиг</th>
                <th className="px-4 py-3">Тайлбар</th>
                <th className="px-4 py-3 w-32">Өнгө</th>
                <th className="px-4 py-3 w-24">Төлөв</th>
                <th className="px-4 py-3 w-32">Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-8">
                    <div className="loading-spinner mx-auto"></div>
                  </td>
                </tr>
              ) : features.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-8 text-gray-500">
                    Давуу тал байхгүй байна. "Шинэ нэмэх" товч дарж эхлээрэй.
                  </td>
                </tr>
              ) : (
                features.map((feature) => (
                  <tr key={feature.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-center font-bold text-lg">
                      {feature.display_order}
                    </td>
                    <td className="px-4 py-3">
                      <div className={`w-12 h-12 rounded-full ${getColorClass(feature.icon_color)} text-white flex items-center justify-center text-xl mx-auto`}>
                        {getIconComponent(feature.icon_name)}
                      </div>
                    </td>
                    <td className="px-4 py-3 font-semibold">{feature.title}</td>
                    <td className="px-4 py-3 text-gray-600 text-sm">
                      {feature.description?.substring(0, 100)}
                      {feature.description?.length > 100 && '...'}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`inline-block px-3 py-1 rounded-full text-white text-xs font-semibold ${getColorClass(feature.icon_color)}`}>
                        {colorOptions.find(c => c.value === feature.icon_color)?.label || feature.icon_color}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      {feature.is_active ? (
                        <span className="badge badge-success">Идэвхтэй</span>
                      ) : (
                        <span className="badge badge-secondary">Идэвхгүй</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex space-x-2 justify-center">
                        <button
                          className="icon-button text-blue-600 hover:bg-blue-50"
                          title="Засах"
                          onClick={() => handleEdit(feature)}
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="icon-button text-red-600 hover:bg-red-50"
                          title="Устгах"
                          onClick={() => handleDelete(feature.id)}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-2xl">
            <div className="modal-header">
              <h3 className="text-xl font-bold text-gray-800">
                {editingFeature ? 'Давуу тал засах' : 'Шинэ давуу тал нэмэх'}
              </h3>
              <button 
                onClick={() => { setShowModal(false); resetForm(); }} 
                className="icon-button"
              >
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="space-y-4">
                  {/* Гарчиг */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Гарчиг <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-input"
                      value={formData.title}
                      onChange={(e) => setFormData({...formData, title: e.target.value})}
                      required
                      placeholder="Жишээ: Хурдан хүргэлт"
                    />
                  </div>

                  {/* Тайлбар */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Тайлбар <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      className="custom-input"
                      rows="3"
                      value={formData.description}
                      onChange={(e) => setFormData({...formData, description: e.target.value})}
                      required
                      placeholder="Жишээ: Олон улсын стандартад нийцсэн хурдан хүргэлт"
                    />
                  </div>

                  {/* Icon сонгох */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Icon сонгох
                    </label>
                    <div className="grid grid-cols-4 md:grid-cols-7 gap-2">
                      {iconOptions.map((icon) => (
                        <button
                          key={icon.name}
                          type="button"
                          onClick={() => setFormData({...formData, icon_name: icon.name})}
                          className={`p-4 border-2 rounded-lg transition flex flex-col items-center justify-center ${
                            formData.icon_name === icon.name
                              ? 'border-blue-500 bg-blue-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                          title={icon.label}
                        >
                          <span className="text-2xl mb-1">{icon.component}</span>
                          <span className="text-xs text-gray-600">{icon.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Өнгө сонгох */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Өнгө сонгох
                    </label>
                    <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
                      {colorOptions.map((color) => (
                        <button
                          key={color.value}
                          type="button"
                          onClick={() => setFormData({...formData, icon_color: color.value})}
                          className={`p-3 border-2 rounded-lg transition ${
                            formData.icon_color === color.value
                              ? 'border-gray-800 scale-110'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                        >
                          <div className={`w-full h-12 rounded ${color.class} flex items-center justify-center text-white text-xl`}>
                            {getIconComponent(formData.icon_name)}
                          </div>
                          <p className="text-xs text-center mt-1 text-gray-600">{color.label}</p>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Дараалал болон Төлөв */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Дараалал
                      </label>
                      <input
                        type="number"
                        className="custom-input"
                        value={formData.display_order}
                        onChange={(e) => setFormData({...formData, display_order: parseInt(e.target.value) || 0})}
                        min="0"
                        placeholder="0"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Бага тоо эхэнд харагдана
                      </p>
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Төлөв
                      </label>
                      <select
                        className="custom-input"
                        value={formData.is_active ? 'true' : 'false'}
                        onChange={(e) => setFormData({...formData, is_active: e.target.value === 'true'})}
                      >
                        <option value="true">Идэвхтэй</option>
                        <option value="false">Идэвхгүй</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={() => { setShowModal(false); resetForm(); }}
                    className="custom-button-secondary"
                    disabled={loading}
                  >
                    <FaTimes className="mr-2" />
                    Цуцлах
                  </button>
                  <button 
                    type="submit" 
                    className="custom-button-success" 
                    disabled={loading}
                  >
                    <FaSave className="mr-2" />
                    {loading ? 'Хадгалж байна...' : 'Хадгалах'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientFeaturesManagement;